import { ChangePassword } from 'components/User';
import {connect} from 'react-redux';
import {changePassword} from 'actions/user';

const mapDispatchToProps = (dispatch) => ({
  changePassword (userData) {
    dispatch(changePassword(userData));
  }
});

export default connect(null, mapDispatchToProps)(ChangePassword);
